import { render } from "./render";
import { $one, $all } from "./querySelector";
import {
  updateCart,
  updateShopifySection,
  addToCartApi,
  readApi,
  updateIds,
} from "./cartApi";
import { Loader } from "../components/loader";
import Swiper, { Navigation, FreeMode } from "swiper";
import { updatePrice, updateVariant } from "../components/product-variant";
import { displayAbonner } from "./display-abonner";


export class Cart {
  constructor() {
    this.sideCartIsOpen = false;
    this.changeRadio();
  }

/* 
* To enable or disabled select add to cart
*/
changeRadio() {
  $all('[name="actions"]').forEach(
    input => {
      input.addEventListener(
        'change',
        (e) => this.changeSelected(e)
      )
    }
  )
}

/**
   * get variant at DOM
   * @param {event} e
   * @returns {obj} current variant
   * @returns {false} not find current varian
   * @author  Edinson Figueroa <edinson.figueroa@gradiweb.com>
*/
getVariantPrice(e) {

  const DomSelector =  e.target.parentElement.parentElement.parentElement.parentElement.querySelector("#current-variant-card");

  if(DomSelector){
    let variantCurrent = JSON.parse(DomSelector.value);
    return this.getPriceCurrentVarian(variantCurrent);
  }else{
    return false;
  }
}

/**
   * get price normal or price suscription 
   * @param {obj} variantCurrent
   * @returns {obj} price normals and price suscription
   * @author  Edinson Figueroa <edinson.figueroa@gradiweb.com>
*/
getPriceCurrentVarian(variantCurrent) {
  const idVariant = variantCurrent.id;

  let price_suscription;
  let price_compare_suscription;

  if(variantCurrent.selling_plan_allocations.length > 0){
     price_suscription = variantCurrent.selling_plan_allocations[0].price;
     price_compare_suscription = variantCurrent.price;
  }else{
     price_suscription = variantCurrent.price;
     price_compare_suscription = variantCurrent.compare_at_price;
  }
     const price_normal = variantCurrent.price;
     const price_compare = variantCurrent.compare_at_price;

     return {
       idVariant,
       price_suscription,
       price_compare_suscription,
       price_normal,
       price_compare
     }
}

/**
   * validate whats function to call 
   * @param {event} e
   * @returns {void} call methods changeProduct or changeCollectionCard
   * @author  Edinson Figueroa <edinson.figueroa@gradiweb.com>
*/
changeSelected(e) {
  const dataVariant = this.getVariantPrice(e);
  if(!dataVariant) {
    this.changeProduct(e);
  }else{
    this.changeCollectionCard(dataVariant, e)
  }
}

/**
   * Change radios and deshability select suscription 
   * @param {event} e
   * @returns {void} 
   * @author  Edinson Figueroa <edinson.figueroa@gradiweb.com>
*/
changeProduct(e) {
  const isVariants = JSON.parse($one('#variants').value);
  if(isVariants.length > 1) {
    const variantIDSelected = Number($one('#variant-selected').value);
    const variantObj = isVariants.filter(variant => variant.id === variantIDSelected)
    
    updateVariant(variantObj[0]); 
  }else{
    updateVariant(isVariants[0]);
  }
  this.changeSelectSelected(e); 
}

/**
   * change radios and disabled select suscription and validate change price  
   * @param {obj} dataVariant
   * @param {event} e 
   * @returns {void} call method change price in DOM
   * @author  Edinson Figueroa <edinson.figueroa@gradiweb.com>
*/
changeCollectionCard(dataVariant, e) {

  const { 
    idVariant, 
    price_suscription,
    price_compare_suscription, 
    price_normal, 
    price_compare} = dataVariant;
    
  this.changeSelectSelected(e);

  if(e.target.classList.contains('suscription')){
    this.changePriceDom(idVariant, price_suscription, price_compare_suscription);
  }else{
    this.changePriceDom(idVariant, price_normal, price_compare); 
  }
}

/**
   * change select in disable o enable
   * @param {event} e 
   * @returns {void}
   * @author  Edinson Figueroa <edinson.figueroa@gradiweb.com>
*/
changeSelectSelected(e) {
  const selected = e.target.parentElement.parentElement.querySelector('#selling-plan-value');
  if(e.target.classList.contains('suscription')){
    selected.removeAttribute('disabled', 'false');
  }else{
    selected.setAttribute('disabled', 'true');
  }
}

/**
   * change price in DOM and validate price_compare with price normal
   * @param {string} idVariant
   * @param {string} price_normal 
   * @param {string} price_compare 
   * @returns {void} show or hidden price in card product 
   * @author  Edinson Figueroa <edinson.figueroa@gradiweb.com>
*/
changePriceDom(idVariant, price_normal, price_compare) {
  const cardCurrent = document.querySelectorAll(`.card_${idVariant}`);

  cardCurrent.forEach((e) => {
    const productcard_price = e.querySelector('.productcard_price');
    const priceDom = e.querySelector('.regular');
    const compareDom = e.querySelector('.compare');
    updatePrice(productcard_price, compareDom, priceDom, price_normal, price_compare)
 
  }) 
}

  /**
   * Binds in corresponding buttons
   */
  bindClicks() {
    // ? Open sidecart
    $one(".icon-cart").addEventListener("click", this.openModal.bind(this));

    // ? Add to cart button product card
    const productCard = $all(".productcard--add-cart");
    if (productCard && productCard.length > 0) {
      productCard.forEach((element) => {
        element.addEventListener("click", this.addToCartProductCard.bind(this));
      });
    }

    this.bindCartClicks();
  }

  /**
   * Binds in corresponding buttons to cart
   */
  bindCartClicks() {
    // ? Add to cart button product card
    const productCard = $all(".side-cart__upsell .productcard--add-cart");
    if (productCard && productCard.length > 0) {
      productCard.forEach((element) => {
        element.addEventListener("click", this.addToCartProductCard.bind(this));
      });
    }

    // ? Close sidecart
    $one("#sideCartOverlay").addEventListener(
      "click",
      this.closeModal.bind(this)
    );
    $one("#sideCartCloseButton").addEventListener(
      "click",
      this.closeModal.bind(this)
    );
    $one("#sideCartOverlay .side-cart").addEventListener("click", (e) =>
      e.stopPropagation()
    );

    // ? More and less product items
    const increaseButtons = $all(".js-increase-product-quantity");
    increaseButtons.forEach((button) => {
      button.addEventListener("click", this.increaseProductQuantity.bind(this));
    });
    const decreaseButtons = $all(".js-decrease-product-quantity");
    decreaseButtons.forEach((button) => {
      button.addEventListener("click", this.decreaseProductQuantity.bind(this));
    });
    const inputQuantityButtons = $all(".js-input-product-quantity");
    if (inputQuantityButtons && inputQuantityButtons.length > 0) {
      inputQuantityButtons.forEach((button) => {
        button.addEventListener(
          "change",
          this.changeProductQuantity.bind(this)
        );
      });
    }

    // ? Remove product
    const removeButtons = $all(".js-product-remove-button");
    removeButtons.forEach((button) => {
      
      button.addEventListener("click", this.removeProduct.bind(this));
    });

    const addToCart = $one("#sideCartButton");
    if (addToCart) {
      addToCart.addEventListener("click", this.redirectToCheckout);
    }

    // ? Assing open and close modal function to upsell in sidecart
    const buttonOpenUpsellModal = $all(".productcard_form .open-modal");
    if (buttonOpenUpsellModal) {
      buttonOpenUpsellModal.forEach((button) => {
        button.addEventListener("click", this.openUpsellModal.bind(this));
      });
    }
    const buttonCloseUpsellModal = $one(
      "#upsell-add-modal #upsell-modal-close"
    );
    if (buttonCloseUpsellModal) {
      buttonCloseUpsellModal.addEventListener("click", this.closeUpsellModal);
    }
  }

  /**
   * Update the header products counter
   * @param {number} itemCount – Number of items inside the cart
   */
  updateCounter(itemCount) {
    const iconCart = $one(".icon-cart");
    const title = iconCart.getAttribute("title").split("(");

    if (!$one(".icon-cart .icon-cart__counter")) {
      render(
        {
          render: () =>
            `<span class="icon-cart__counter">(${itemCount})</span>`,
        },
        iconCart
      );
      title[1] = `(${itemCount})`;
    } else if (itemCount === 0 && $one(".icon-cart .icon-cart__counter")) {
      $one(".icon-cart .icon-cart__counter").remove();
      title[1] = `(0)`;
    } else {
      $one(".icon-cart .icon-cart__counter").innerHTML = `(${itemCount})`;
      title[1] = `(${itemCount})`;
    }

    iconCart.setAttribute("title", title.join(""));
  }

  /**
   * Update the shopping cart
   */
  async update() {
    render(new Loader(), $one(".side-cart"));

    const content = await updateShopifySection("side-cart");
    $one("#sideCartContent").innerHTML = content;

    if (this.sideCartIsOpen) {
      $one("#sideCartOverlay").classList.add("is-active");
    }

    const cartPage = $one(".cart-page");
    if (cartPage) {
      if (!this.sideCartIsOpen) {
        render(new Loader(), cartPage);
      }

      const cartContent = await updateShopifySection("main-cart-items");
      const elementCartContent = $one("#cart-content");
      elementCartContent.insertAdjacentHTML("afterend", cartContent);
      elementCartContent.remove();
    }

    this.bindCartClicks();
    this.sliderUpsell();
    this.changeRadio();
  }

  /**
   * Remove product from cart.
   * @param {object} event – Event to handle.
   */
  removeProduct(event) {
    this.changeProductQuantity(event, 0);
  }

  /**
   * Increase product quantity.
   * @param {object} event – Event to handle.
   */
  increaseProductQuantity(event) {
    const quantity = Number(event.target.parentNode.dataset.quantity);
    this.changeProductQuantity(event, quantity + 1);
  }

  /**
   * Decrease product quantity.
   * @param {object} event – Event to handle.
   */
  decreaseProductQuantity(event) {
    const quantity = Number(event.target.parentNode.dataset.quantity);
    this.changeProductQuantity(event, quantity - 1);
  }

  /**
   * Change product quantity.
   * @param {object} event – Event to handle.
   * @param {number} newQuantity – new product quantity.
   */
  async changeProductQuantity(event, newQuantity = -1) {
    const target = event.target;
    const line_item = Number(target.parentNode.dataset.lineIndex);
    console.log("aqui", line_item);
    const buttonRemove = event.target.closest('.js-product-remove-button');
    const bundle = buttonRemove?.dataset.elements;
    const cartPage = buttonRemove?.dataset.cart;
    const updates = {} ;
    if (newQuantity === -1) {
      newQuantity = Number(target.value);
    }

    const item = {
      line: line_item,
      quantity: newQuantity,
    };

    if(bundle){
      bundle.split('-').map((element) => updates[element] = 0);
    }
    const cart = !!bundle ? await updateIds(updates) : await updateCart(item);

    let cartSize = 0;
    if (cart && cart.items) {
      cartSize = cart.items.length;
    }
    this.updateCounter(cartSize);
    await this.update();

    if(cartPage){
      window.location.reload(true)
    }
  }

  /**
   * Open the side modal of the cart.
   */
  async openModal() {
    this.sideCartIsOpen = true;
    $one("#sideCartOverlay").classList.add("is-active");
    await this.update();
  }

  /**
   * Close the side modal of the cart.
   */
  closeModal(event) {
    event.stopPropagation();
    this.sideCartIsOpen = false;
    if ($one("#sideCartOverlay").classList.contains("js-close-side-cart")) {
      $one("#sideCartOverlay").classList.remove("is-active");
    }
  }

  /**
   * Redirect to checkout
   */
  redirectToCheckout() {
    window.location.replace("/checkout");
  }

  /**
   * Init slider upsell
   */
  sliderUpsell() {
    new Swiper(".js-upsell-slider", {
      modules: [Navigation, FreeMode],
      spaceBetween: 30,
      freeMode: true,
      clickable: true,

      breakpoints: {
        768: {
          spaceBetween: 20,
          autoHeight: true,
          slidesPerView: "auto",
          direction: "vertical",
          navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
          },
        },
      },
    });
    displayAbonner()
  }

  /**
   * Add to cart button in product card
   */
  async addToCartProductCard(event) {

    const parent = event.target.parentElement;

    const className = event.target.getAttribute("data-class");
    const productId = event.target.getAttribute("data-id");
    const sectionId = event.target.getAttribute("data-section");
    const inputId = `sabonner-${className}-${productId}-${sectionId}`;

    const variant = Number(parent.querySelector(`#variant-${productId}`).value);
    const items = [
      {
        id: variant,
        quantity: 1,
      },
    ];

    if (
      parent.querySelector(
        `input[id=${inputId}][type="radio"][name="actions"]:checked`
      )
    ) {
      items[0].selling_plan = parent.querySelector(
        `#selling-plan-value[data-id=${inputId}]`
      ).value;
    }

    
    try {
      await addToCartApi(items);
      this.updateCartSuccess(); 

    } catch (error) {
        this.openCartMessage();
    }

  }

  openCartMessage(){
    this.sideCartIsOpen = true;
    $one("#sideCartOverlay").classList.add("is-active");
    this.sliderUpsell();
    $one('.side-cart__message').style.display = 'flex';
    setTimeout(() => {
      $one('.side-cart__message').style.display = 'none';
    }, 3000)
  }
  
   async updateCartSuccess(){ 
     const cart = await readApi('/cart.js');

      this.updateCounter(cart.items.length);
      this.openModal();
    } 
  

  

  /**
   * Open modal in upsell to add to cart products with selling plan
   */
  openUpsellModal(event) {
    const dataId = event.target.getAttribute("data-modal");
    const form = $one(`#${dataId}`);
    const modal = $one("#upsell-add-modal .product-card-modal");
    modal.innerHTML = "";
    modal.appendChild(form);
    $one("#upsell-add-modal").classList.add("show");

    // ? Add to cart button product card
    const productCard = $all(".side-cart__upsell .productcard--add-cart");
    if (productCard && productCard.length > 0) {
      productCard.forEach((element) => {
        element.addEventListener("click", this.addToCartProductCard.bind(this));
      });
    }
  }

  /**
   * Close modal in upsell to add to cart products with selling plan
   */
  closeUpsellModal() {
    const modal = $one("#upsell-add-modal .product-card-modal");
    modal.innerHTML = "";
    $one("#upsell-add-modal").classList.remove("show");
  }
}
